<div>
  <div class="vs-homepage-overlay" #siteTourOverlay></div>

  <div class="help-menu-container">
    <div class="title-section">
      <em class="material-icons custom-close" (click)="closeMenuOverlay()"
        >close</em
      >
      <span class="help-title">{{ "help.help" | cxTranslate }}</span>
    </div>
    <!-- PAGINATION symbol to load on screen - START -->
    <div class="spinner-class" *ngIf="displayLoader">
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    </div>
    <!-- PAGINATION symbol to load on screen - END -->
    <div class="icons-section" *ngIf="!displayLoader">
      <div class="icons-group">
        <a class="icon-individual" [href]="pdfTrainingLink" target="_blank">
          <span class="outer-icon">
            <em class="material-icons icon-size">assessment</em>
          </span>
          <span class="icon-desc">{{ "help.training" | cxTranslate }}</span>
        </a>

        <div class="icon-individual none" (click)="triggerSiteTour()">
          <span class="outer-icon">
            <em class="material-icons icon-size">directions_walk</em>
          </span>
          <span class="icon-desc">{{ "help.sittour" | cxTranslate }}</span>
        </div>

        <div class="icon-individual" (click)="triggerFeedback()">
          <span class="outer-icon">
            <em class="material-icons icon-size">feedback</em>
          </span>
          <span class="icon-desc">{{ "help.feedback" | cxTranslate }}</span>
        </div>

        <div class="icon-individual" (click)="triggerVideoTutorial()">
          <span class="outer-icon">
            <em class="material-icons icon-size">videocam</em>
          </span>
          <span class="icon-desc">{{ "help.video" | cxTranslate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
